import React, {Fragment, useState} from 'react';
import {connect} from "react-redux";

import {postGenerateAiImage, setDefaultPrompts} from "./aiApi";
import MultiLoader from "../ui/multiLoader";
import Config from "../../config";
import {setUiPopupState} from "../../actions/actionFunctions";
import {UI_POPUP_TYPES} from "../../reducers/messageBoxReducer";
import {AiIcon} from "../common/svgIcons/svgIcons";
import {setAILoading} from "./aiActions";
import {abortCurrent, getSignal, newController} from "./aiController";


const AIButton = (props) => {

  const {setUiPopupState, aiLoading, setAILoading, postGenerateAiImage} = props;

  const [responseImg, setResponseImg] = useState("");

  if (!Config.isDevMode()) {
    return null
  }

  const generateImage = async (closePopup, uiPopupContext) => {
    console.log("uiPopupContext", uiPopupContext);
    if (aiLoading) {
      abortCurrent();
      closePopup();
      return
    }
    closePopup();
    const controller = newController(); // replace the shared controller
    const responseImg = await postGenerateAiImage(uiPopupContext, controller.signal ?? getSignal());
    if (responseImg) {
      setResponseImg(responseImg);
    }
  }

  const onSaveClick = async (closePopup, uiPopupContext, intl, p) => {
    console.log(this, intl, p);
    let startText = "";
    if(p) {
      startText = p.innerText;
      p.disabled = true;
      p.innerText = "Saving...";
    }
    
    const { promptsList } = uiPopupContext;
    const activePromptFirst = promptsList.find(promptObject => promptObject.isActiveFirst);
    const activePromptSecond = promptsList.find(promptObject => promptObject.isActiveSecond);
    const activePromptThird = promptsList.find(promptObject => promptObject.isActiveThird);
    await setDefaultPrompts(activePromptFirst, activePromptSecond, activePromptThird);
    if(p) {
      p.disabled = false;
      p.innerText = "Saved.";
      window.setTimeout(() => p.innerText = startText, 1500);
    }
    else {
      closePopup();
    }
  }

  const aiButtonClick = () => {
    setUiPopupState({
      headerTextId: "overlays.specifications",
      className: "",
      style: {maxWidth: "1024px", maxHeight: "560px"},
      opened: true,
      type: UI_POPUP_TYPES.aiPopup,
      context: {},
      // onCloseClick: (isCancel) => {
      //   if (isCancel) {
      //     closeContracts();
      //   }
      // },
      buttons: [{
        isSaveButton: false,
        className: "ui-button2 text-uppercase ui-button2--green",
        textId: "buttons.save",
        onClick: onSaveClick,
      }, {
        className: "ui-button2 text-uppercase ui-button2--blue ml-1"
      }, {
        isSaveButton: true,
        className: "ui-button2 text-uppercase ui-button2--green ml-1",
        textId: aiLoading ? "buttons.stop" : "buttons.generateAi",
        onClick: generateImage,
      }],
    });
  }

  const closePopup = () => {
    setAILoading(false);
    setResponseImg("");
  }

  return (
    <Fragment>
      <button className="mobilebutton block color-primary p-05 fixed"
             style={{zIndex: 100, right: "2rem", bottom: "2rem",}}
             onClick={aiButtonClick}>
        {AiIcon}
        <span className="mobilebutton-text">Ai Generate</span>
      </button>
      {!Config.isDevMode() && (aiLoading || responseImg) ? (
        <div className="w-full h-full fixed bg-white flex flex--center" style={{left: 0, top: 0, zIndex: 10}}>
          <div className="ui-close absolute" onClick={closePopup} style={{right: "2rem", top: "5.5rem", zIndex: 100}} />
          {responseImg ? <img src={responseImg} alt="" className=""/> : null}
          {aiLoading ? <MultiLoader/> : null}
        </div>
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = (store) => {
  const {aiLoading} = store.aiState;
  return {
    activeTheme: store.serverState.activeTheme,
    aiLoading,
  };
};

const mapDispatchToProps = {
  setUiPopupState,
  postGenerateAiImage,
  setAILoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(AIButton)
